export default __webpack_public_path__ + "static/media/lasko_mobile_temna3.ee335633.jpg";